import Pill from './Pill.jsx';
import InfoIcon from './InfoIcon.jsx';
import './CourseCard.css';

const CATEGORY_LABELS = {
  'core': 'Core',
  'fine-arts': 'Fine Arts',
  'pe': 'PE',
  'elective': 'Elective',
};

export default function CourseCard({ course }) {
  const {
    name,
    code,
    grade,
    category,
    required,
    advanced,
    hsCredit,
    description,
    prerequisites,
    fieldTrips,
    notes,
    source,
    verificationNeeded,
    verificationNote,
  } = course;

  const hasDetails =
    (prerequisites && prerequisites.length > 0) ||
    fieldTrips ||
    notes;

  // Merge verificationNote into the source so the InfoIcon popover shows
  // the course-specific reason, not just the generic catalog note.
  const effectiveSource =
    verificationNeeded && verificationNote
      ? { ...source, note: verificationNote, verificationNeeded: true }
      : source;

  return (
    <div className={`course-card${verificationNeeded ? ' course-card--caution' : ''}`}>

      {/* ── Top row: name + code + InfoIcon ── */}
      <div className="course-card-top">
        <div className="course-card-title-block">
          <h3 className="course-card-name">{name}</h3>
          {code && <span className="course-card-code">{code}</span>}
        </div>
        <InfoIcon source={effectiveSource} />
      </div>

      {/* ── Pills ── */}
      <div className="course-card-pills">
        <Pill variant="primary" size="sm">{grade}</Pill>
        <Pill variant="default" size="sm">{CATEGORY_LABELS[category] ?? category}</Pill>
        {required && <Pill variant="required" size="sm">Required</Pill>}
        {advanced && <Pill variant="advanced" size="sm">⭐ Advanced</Pill>}
        {hsCredit && <Pill variant="hs-credit" size="sm">🎓 HS Credit</Pill>}
      </div>

      {/* ── Description ── */}
      <p className="course-card-description">{description}</p>

      {/* ── Expandable details ── */}
      {hasDetails && (
        <details className="course-card-details">
          <summary className="course-card-details-summary">More info</summary>
          <div className="course-card-details-body">
            {prerequisites && prerequisites.length > 0 && (
              <div className="course-detail-row">
                <span className="course-detail-label">Prerequisites</span>
                <ul className="course-detail-list">
                  {prerequisites.map((p, i) => (
                    <li key={i}>{p}</li>
                  ))}
                </ul>
              </div>
            )}
            {fieldTrips && (
              <div className="course-detail-row">
                <span className="course-detail-label">Field trips</span>
                <p className="course-detail-text">{fieldTrips}</p>
              </div>
            )}
            {notes && (
              <div className="course-detail-row">
                <span className="course-detail-label">Notes</span>
                <p className="course-detail-text">{notes}</p>
              </div>
            )}
          </div>
        </details>
      )}
    </div>
  );
}
